import script from "./SearchHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchHistory.vue?vue&type=script&setup=true&lang=ts"

import "./SearchHistory.vue?vue&type=style&index=0&id=c1cc6c48&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1cc6c48"]])

export default __exports__